import React, { useContext, useMemo, useRef, useState } from 'react';
import { ReferenceArrayInput, useDataProvider } from 'react-admin';
import { Grid } from '@material-ui/core/';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { FormSpy } from 'react-final-form';
import { connect } from 'react-redux';

import GridInput from '../../../core/components/inputs/GridInput';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import { CreationContactContext } from '../creationsteps/CreationContactContext';
import GridInputChoices from './GridInputChoices';
import { getFundFamiliesIds, referenceArrayInputProps } from './utils';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const AddAuthorization = props => {
  const {
    userTypeRoleCheck,
    onSubmitEnd,
    reduxFunds,
    selectedPermissionGroups,
    setSelectedPermissionGroups,
    creation
  } = props;

  const [editFormValues, setEditFormValues] = useState();
  const dataProvider = useDataProvider();
  const notifyServerError = useNotifyServerError();
  const context = useContext(CreationContactContext);
  const allFunds = useMemo(() => Object.values(reduxFunds), [reduxFunds]);

  const formRef = useRef();

  const handleSubmit = formValues => {
    if (
      Array.isArray(formValues.investors) &&
      formValues.investors.length > 0
    ) {
      dataProvider
        .getList('fundinvestors', {
          pagination: { perPage: -1 },
          filter: { investorId: `[${formValues.investors}]` }
        })
        .then(({ data }) => {
          context.setContactContext({
            permissionGroupSelect: data
          });
        })
        .catch(error => {
          notifyServerError(error, undefined);
        });
    } else if (Array.isArray(formValues.funds) && formValues.funds.length > 0) {
      const selectedFunds =
        allFunds.length === formValues.funds.length
          ? allFunds
          : allFunds.filter(item => formValues.funds.includes(item.id));

      const fundFamiliesIds = [];
      getFundFamiliesIds(selectedFunds, fundFamiliesIds);

      if (fundFamiliesIds.length > 0) {
        dataProvider
          .getMany('fundfamilies', {
            ids: fundFamiliesIds,
            target: 'id'
          })
          .then(({ data }) => {
            const dataWithFundFamilies = selectedFunds.map(fund => {
              const fundFamily = data.find(
                item => item.id === fund.fundFamilyId
              );
              return {
                fundId: fund.id,
                fundName: fund.name,
                fundFamilyId: fundFamily && fundFamily.id,
                fundFamilyName: fundFamily && fundFamily.name,
                investorId: '*'
              };
            });
            context.setContactContext({
              permissionGroupSelect: dataWithFundFamilies
            });
          })
          .catch(error => {
            notifyServerError(error, undefined);
          });
      } else {
        const dataWithFunds = selectedFunds.map(fund => {
          return {
            fundId: fund.id,
            fundName: fund.name,
            investorId: '*'
          };
        });

        context.setContactContext({
          permissionGroupSelect: dataWithFunds
        });
      }
    }
    onSubmitEnd();
  };

  const isRegular = userTypeRoleCheck;

  const additionalFilterProps = {
    attributeToFilter: 'fundFamilyName', // Should be named after the attribute we want to search for
    emptyText: 'Fund Families',
    placeholder: 'Fund Families'
  };

  return (
    <CustomSimpleForm
      save={handleSubmit}
      initialValues={selectedPermissionGroups}
      toolbar={null}
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {newFormProps => {
          formRef.current = newFormProps.form;
          if (!isEqual(editFormValues, newFormProps.values)) {
            setTimeout(() => {
              setEditFormValues(newFormProps.values);
              setSelectedPermissionGroups(newFormProps.values);
            }, 1);
          }
          if (context.contactContext.currentForm === undefined) {
            context.setContactContext(prev => ({
              ...prev,
              currentForm: newFormProps.form
            }));
          }
          return (
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <ReferenceArrayInput
                  {...referenceArrayInputProps(isRegular, true)}
                >
                  <GridInputChoices
                    {...props}
                    allFunds={allFunds}
                    usedIds={undefined}
                    emptyText={
                      isRegular
                        ? 'There are no Investors to be displayed.'
                        : 'There are no Funds to be displayed.'
                    }
                  >
                    <GridInput
                      height={
                        creation
                          ? `${document.documentElement.scrollHeight - 432}px`
                          : '500px'
                      }
                      additionalFilterProps={additionalFilterProps}
                      showAdditionalFilter={!isRegular}
                    />
                  </GridInputChoices>
                </ReferenceArrayInput>
              </Grid>
            </Grid>
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

const mapStateToProps = state => {
  return {
    reduxFunds: get(state, 'admin.resources.funds.data', {})
  };
};

export default connect(mapStateToProps, {})(AddAuthorization);
